import React from "react";
import css from "./Tabs.module.css";
import cn from "classnames";

interface TabsProps {
    tabs: {
        label: string;
        tabKey: string;
    }[];
    onSelect: (tabKey: string) => void;
    activeTabKey: string;
}

export const Tabs: React.FC<TabsProps> = ({ tabs, onSelect, activeTabKey }) => {
    return (
        <div className={cn(css.main, "typography-subtitle")}>
            {tabs.map((tab) => (
                <div
                    key={tab.tabKey}
                    className={cn(css.tab, {
                        [css.active]: activeTabKey === tab.tabKey,
                    })}
                    onClick={() => onSelect(tab.tabKey)}
                >
                    {tab.label}
                </div>
            ))}
        </div>
    );
};
